export default __webpack_public_path__ + "static/media/backArrow.9b63ea44.svg";